//* 답례품 노출 판정 — 상조 단계 두 가지
//* 1) 상조 전체 실행(featureFlags.giftEnabled === true): 모든 지도사 상가에 노출, 지도사 giftPilot은 의미 없음
//* 2) 상조 실행 전(giftEnabled 꺼짐): giftPilot이 켜진 지도사의 상가에만 노출(파일럿)
//* 백엔드 답례 알림톡·전환 분석도 같은 규칙이어야 한다(docs/gift-pilot-two-state-spec.md).
import { BugoBrandFeatureFlags } from '@shared/api/bugoBrand/bugoBrand.interface';

type BrandLike = { featureFlags?: BugoBrandFeatureFlags } | null | undefined;

/** 상조가 답례품을 전체 실행 중인가 — 이때 지도사 파일럿 설정은 무시된다 */
export const isGiftBrandLive = (bugoBrand: BrandLike): boolean =>
  bugoBrand?.featureFlags?.giftEnabled === true;

/** 이 상가(부고)에 답례품을 노출하는가 */
export const resolveGiftUse = (
  bugoBrand: BrandLike,
  workerGiftPilot: boolean | undefined,
): boolean => isGiftBrandLive(bugoBrand) || workerGiftPilot === true;
